import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

const values = [
  {
    icon: 'ri-focus-3-line',
    title: '精选内容',
    desc: '我们只收录兼具品质与表达的成人向短篇剧集，拒绝低质与泛滥，帮助用户高效发现真正值得一看的作品。',
  },
  {
    icon: 'ri-book-open-line',
    title: '深度解读',
    desc: '不止于剧情介绍。我们提供专业的影评专题与观看视角，让每一部短剧都被更完整地理解。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '严谨分级',
    desc: '坚持 18+ 内容分级提示，尊重成年观众的判断力，同时保持内容的体面与分寸。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '以用户为中心',
    desc: '多维筛选、演员索引与全站搜索，让浏览与发现都尽可能顺畅、清晰。',
  },
];

const team = [
  { name: '内容编辑部', role: '剧集策划与资料整理', desc: '负责短剧选题、剧情资料与演员信息的编辑与校对。' },
  { name: '影评专栏组', role: '深度解读与专题撰写', desc: '从叙事、视觉与题材视角，产出专业而克制的影评内容。' },
  { name: '产品体验组', role: '浏览体验与内容组织', desc: '设计分类、筛选与搜索的信息架构，让发现更简单。' },
];

export default function About() {
  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-5">
          <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-foreground-300">关于我们</span>
        </nav>

        <section className="relative overflow-hidden rounded-xl border border-background-800 bg-background-900 px-6 py-12 md:px-12 md:py-16">
          <div className="relative z-10 max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-900/60 px-3 py-1 text-xs text-accent-200">
              <i className="ri-clapperboard-fill" /> 关于成人短剧
            </span>
            <h1 className="mt-5 text-3xl md:text-5xl font-bold text-foreground-50 font-heading leading-tight">
              专注成人向短篇影视剧的精选导览
            </h1>
            <p className="mt-5 text-sm md:text-base leading-loose text-foreground-300">
              成人短剧是一个面向 18 岁以上观众的短篇影视内容平台。我们以专业、严肃的专题导览为定位，
              聚合丰富的成人向短篇剧集，提供剧集分类、剧情介绍、演员资料与深度影评，
              帮助用户在纷繁的内容中更快找到真正符合口味的高质量短篇作品。
            </p>
          </div>
        </section>

        <section className="mt-12">
          <h2 className="flex items-center gap-2 text-xl md:text-2xl font-bold text-foreground-50 mb-6">
            <span className="block w-1 h-5 rounded-full bg-primary-500" />
            服务宗旨
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {values.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-800 bg-background-900/50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100/15 text-primary-300">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-50">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-400">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <h2 className="flex items-center gap-2 text-xl md:text-2xl font-bold text-foreground-50 mb-6">
            <span className="block w-1 h-5 rounded-full bg-accent-500" />
            团队介绍
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {team.map((member) => (
              <div key={member.name} className="rounded-lg border border-background-800 bg-background-900/50 p-6">
                <h3 className="text-lg font-semibold text-foreground-50">{member.name}</h3>
                <p className="mt-1 text-xs text-accent-300">{member.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-400">{member.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 rounded-xl border border-background-800 bg-background-900/60 p-6 md:p-8">
          <h2 className="text-lg font-bold text-foreground-50">免责声明与隐私说明</h2>
          <div className="mt-4 space-y-3 text-sm leading-loose text-foreground-400">
            <p>
              本网站为产品演示项目，页面上所有的短剧、演员、影评及用户评价数据均为<strong className="text-foreground-200">虚构示例内容</strong>，
              不指向任何真实作品、人物或机构，也不提供任何真实的在线播放服务。
            </p>
            <p>
              本站内容仅面向 18 岁以上的成年用户，建议用户理性观影，遵守所在地的相关法律法规。
            </p>
            <p>
              本站不收集用户的个人身份信息。收藏功能仅通过浏览器本地存储记录，不会上传至服务器；联系表单所收集的信息仅用于处理用户反馈。
            </p>
            <p>如对本网站内容有任何疑问或建议，欢迎通过<Link to="/contact" className="text-primary-400 hover:text-primary-300 cursor-pointer">联系我们</Link>页面与我们取得联系。</p>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}